/* eslint-disable */
import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes, Redirect, BrowserRouter, useParams } from 'react-router-dom'
import { parseCookies  } from 'nookies'
import './scss/style.scss'





const loading = (
  <React.Fragment>
    {/* <audio src="/epic-dramatic-action-trailer-99525.mp3" autoPlay loop style={{ display: "none" }} /> */}
    <img className="mb-4" src={'https://media4.giphy.com/media/bHSkKRvkRvy5chUBBp/giphy.gif'} alt="Loading..." style={{
      // fullscreen
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      // center
      margin: "auto",
      // size
      width: "100%",
      height: "100%",
      // background
      backgroundColor: "black",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",

    }} />

  </React.Fragment>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))



if(window?.location?.href){
  const host = window.location.host
  const isDEV = host.includes("localhost") || host.includes("152.53.23.48")
  localStorage.setItem('DEV', isDEV);

  console.log("isDEV", isDEV)

  const versions = {
    "app.reputationsritter.de":"RR",
    "app.my-websolutions.de":"MW",
    "app.repufox.com":"RF",
    "localhost:3000":"MW",
  }

  window.version = versions[host]

  const {
    REACT_APP_API_URL,
  } = process.env;

  if(REACT_APP_API_URL?.length > 0) {
    window.FRONTEND_API_URL = REACT_APP_API_URL
  } else {
    window.FRONTEND_API_URL = isDEV ? "http://152.53.23.48:1338" : "https://api2.ratingritter.de"
  }
  window.MEDIA_URL = isDEV ? "" : ""
}

class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      user:undefined,
      isChrome: true
    }
  }

  componentDidMount() {
    this.checkBrowser()
  }

  checkBrowser() {
    const userAgent = navigator.userAgent;
    const isChrome = userAgent.includes("CriOS") || userAgent.includes("Chrome") || userAgent.includes("Chromium");
    this.setState({ isChrome });
  }

  async getUser(){
    const me = await fetch(`${window.FRONTEND_API_URL}/api/users/me?populate=role,img,sip,email_settings,email_settings_outbound,phonesetup,team,managed_teams,agency.logo,agency.owner`, {
      method: "GET",
      headers: {
        "accept": "application/json, text/plain, */*",
        "content-type": "application/json;charset=UTF-8",
        'Authorization': `Bearer ${parseCookies().jwt}`,

      },
    })

    const meResponse = await me.json();

    window.user = meResponse
    this.setState({user:meResponse})
    window.logo = meResponse?.agency?.logo?.url
    window.ST = meResponse?.agency?.short === "ST"


    const managed_teams = window.user.managed_teams.map(t => t.id)
    const team = window.user?.team?.id
    window.all_teams = [...new Set([team, ...managed_teams].filter(t => t))]
  }

  render() {
    const {user, isChrome} = this.state
    const cookies = parseCookies()
    let jwt = cookies.jwt

    if (!isChrome) {
      // Zeigt eine benutzerdefinierte Komponente an, wenn der Browser nicht Chrome ist
      return <BrowserNotSupported />;
    }

    if (!jwt) {
      return <BrowserRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route path="*" name="Home" element={<Login />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    }

    if (!user) {
      this.getUser()
      return loading
    }

    if (user.role.name) {
      return (
        <BrowserRouter>
          <Suspense fallback={loading}>
            <Routes>
              <Route exact path="/login" name="Login Page" element={<Login />} />
              <Route exact path="/register" name="Register Page" element={<Register />} />
              <Route exact path="/404" name="Page 404" element={<Page404 />} />
              <Route exact path="/500" name="Page 500" element={<Page500 />} />
              <Route path="*" name="Home" element={<DefaultLayout />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      )
    }

    return <h1>Error beim Login!</h1>

  }
}

const BrowserNotSupported = () => (
  <div style={{ textAlign: 'center', marginTop: '50px' }}>
    <h1>Dein Browser wird nicht unterstützt.</h1>
    <p>Bitte nutze  <a href="https://www.google.com/chrome/">Google Chrome</a>, um das CRM zu verwenden.</p>
  </div>
);


export default App


